import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { UtilCryptography } from 'src/app/5.transversal/5.2.utils/util.cryptography/util.cryptography';
import { ModelDefaultResponse } from  'src/app/4.repository/4.3.model/model.default.response';

@Injectable({
    providedIn: 'root'
})
export class HttpInterceptor implements HttpInterceptor {

    constructor(
        private cryptography: UtilCryptography
    ){}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        var headers = {
            'Content-Type': 'application/json'
        }
        request = request.clone({
            setHeaders: (headers),
        });
        return next.handle(request).pipe(
            timeout(180000),
            map(event => {
                if(event instanceof HttpResponse){
                    try{
                        if(String(event.body).includes('true')){
                            let objValidation: ModelDefaultResponse<any> = {
                                codeStatus: "OK",
                                data: true,
                                message: "La validación fue exitosa.",
                                status: true
                            }
                            return event.clone({
                                body: objValidation
                            });
                        }
                        let decryptedText = this.cryptography.decrypt(event.body.data);
                        let objReturn: ModelDefaultResponse<any> = JSON.parse(decryptedText);
                        return event.clone({
                            body: objReturn
                        });
                    }catch(ex){
                        let objError: ModelDefaultResponse<any> = {
                            codeStatus: "0x0a",
                            data: null,
                            message: "Ocurrió un error al decodificar la información",
                            status: false
                        }
                        return event.clone({
                            body: objError
                        });
                    }
                }
            })
        );
    }

}